module.exports = __webpack_public_path__ + "static/media/lb.8e9c186c.svg";